var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video_ikon",
    transform: "translate(-1859.505 -601.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10868",
    d: "M1886.005,632.2h-22a4.5,4.5,0,0,1-4.5-4.5v-22a4.5,4.5,0,0,1,4.5-4.5h22a4.5,4.5,0,0,1,4.5,4.5v22A4.506,4.506,0,0,1,1886.005,632.2Zm-22-30a3.5,3.5,0,0,0-3.5,3.5v22a3.5,3.5,0,0,0,3.5,3.5h22a3.505,3.505,0,0,0,3.5-3.5v-22a3.5,3.5,0,0,0-3.5-3.5Z",
    fill: "#929ea7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10869",
    d: "M1878.356,616.917l6.065,3.5a1.009,1.009,0,0,0,1.514-.874v-7a1.009,1.009,0,0,0-1.514-.874l-6.065,3.5A1.008,1.008,0,0,0,1878.356,616.917Z",
    fill: "#929ea7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10870",
    d: "M1876.923,608.806H1866.1a1.955,1.955,0,0,0-1.96,1.951v10.83a1.963,1.963,0,0,0,1.96,1.959h10.82a1.963,1.963,0,0,0,1.96-1.959v-10.83A1.955,1.955,0,0,0,1876.923,608.806Zm-2.24,7.7-4.94,2.849a.537.537,0,0,1-.81-.459v-5.7a.54.54,0,0,1,.81-.471l4.94,2.851A.535.535,0,0,1,1874.683,616.507Z",
    fill: "#929ea7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/videoIcon.75ed43e4e04913bc3c7a8d490e8dbff2.svg";
export { ForwardRef as ReactComponent };